import { effect, inject } from '@angular/core';
import { APP_SESSION } from '@indutrust/shared-model';
import { AnalyticsService } from './analytics.service';

/** Keeps PostHog identity in sync with the brand-provided {@link APP_SESSION}. */
export function syncSessionIdentity(): () => void {
  return () => {
    const analytics = inject(AnalyticsService);
    const session = inject(APP_SESSION, { optional: true });

    if (!session) {
      return;
    }

    effect(() => {
      const user = session.user();

      if (session.isAuthenticated() && user) {
        analytics.identifyUser(String(user.id), {
          company_id: user.company_id,
          user_type: user.type,
        });
        return;
      }

      analytics.reset();
    });
  };
}
